import { Injectable } from '@angular/core';

declare let gtag: any;

@Injectable({
    providedIn: 'root',
})
export class AnalyticsService {
    /**
     * This method is used for tracking the event of interest into the Google Analytics suite. Intended use of this method
     * is to be imported into a particular component where it could be called over the event(s) we are interested.
     *
     * See the footer component for the example of usage.
     * */
    trackEvent(
        eventName: string,
        eventDetails: string,
        eventCategory: string
    ): void {
        gtag('event', eventName, {
            // event Type - example: 'SCROLL_TO_TOP_CLICKED'
            event_category: eventCategory,
            // the label that will show up in the dashboard as the events name
            event_label: eventName,
            // a short description of what happened
            value: eventDetails,
        });
    }
}
